import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "@/components/ui/sonner";
import Header from "@/components/Header";
import Hero from "@/components/Hero";
import TrustStrip from "@/components/TrustStrip";
import Marquee from "@/components/Marquee";
import Services from "@/components/Services";
import Sectors from "@/components/Sectors";
import ImageBreak from "@/components/ImageBreak";
import TrackRecord from "@/components/TrackRecord";
import Engagements from "@/components/Engagements";
import Leadership from "@/components/Leadership";
import InTheField from "@/components/InTheField";
import Stats from "@/components/Stats";
import GlobalReach from "@/components/GlobalReach";
import Insights from "@/components/Insights";
import Contact from "@/components/Contact";
import Footer from "@/components/Footer";
import ArticlePage from "@/pages/ArticlePage";
import SectorPage from "@/pages/SectorPage";

const Landing = () => (
  <>
    <Header />
    <main>
      <Hero />
      <TrustStrip />
      <Marquee />
      <Services />
      <Sectors />
      <ImageBreak />
      <TrackRecord />
      <Engagements />
      <Leadership />
      <InTheField />
      <Stats />
      <GlobalReach />
      <Insights />
      <Contact />
    </main>
    <Footer />
  </>
);

const Article = () => (
  <>
    <Header />
    <ArticlePage />
    <Footer />
  </>
);

const Sector = () => (
  <>
    <Header />
    <SectorPage />
    <Footer />
  </>
);

export default function App() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.25, smoothWheel: true });
    window.__lenis = lenis;
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <div
      data-testid="byot-app"
      className="min-h-screen bg-[#070E1B] font-sans text-[#F7F5F0] antialiased selection:bg-[#D4AF37] selection:text-[#070E1B]"
    >
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/insights/:slug" element={<Article />} />
          <Route path="/sectors/:slug" element={<Sector />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" theme="dark" />
    </div>
  );
}
